import React from "react";

import "./Button.css";

const Button = (props) => {
  return (
    <button
      className={`btn zoom ${props.className || "text-dark"}`}
      style={{
        backgroundColor: `${props.text}`,
        borderRadius: "2vmin",
        width: "90%",
        height: "19vmin",
      }}
    >
      {props.children}
    </button>
  );
};

export default Button;
